export const validCalendarReviewVersion = (value) => typeof value === 'string' && /^[0-9a-f]{64}$/.test(value)

export function calendarReviewRequest(reviewVersion, approved, reason = null) {
  if (!validCalendarReviewVersion(reviewVersion))
    throw new Error('Atualize a lista de eventos para obter a versão atual antes de revisar.')
  return { approved, reason, reviewVersion }
}

export function calendarReviewError(response) {
  if (response?.status === 409 || response?.code === 'CALENDAR_REVIEW_STALE')
    return 'O evento ou a política da fonte mudou. Atualize a lista e confira a versão atual antes de aprovar ou rejeitar.'
  if (response?.code === 'CALENDAR_REVIEW_VERSION_REQUIRED')
    return 'Atualize a lista de eventos para obter a versão atual antes de revisar.'
  return response?.error || 'Não foi possível revisar o evento.'
}
